<ng-template #icon let-name>
    <svg aria-hidden="true" class="icon" fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
         viewBox="0 0 24 24" width="18">
        <path [attr.d]="icons[name]"></path>
    </svg>
</ng-template>

<a [routerLink]="['/', Routenames.seire]" aria-label="CRM26" class="brand">
    @if (!state.collapsed()) {
        <span class="word">codalt</span>
    }
    <span class="brace">{{ '{' }}</span>
    @if (!state.collapsed()) {
        <span class="app">CRM26</span>
    }
</a>

@if (loggedIn() && orbs().length) {
    <a [attr.aria-label]="statusLabel()" [routerLink]="['/', Routenames.seire]" class="status">
        @for (orb of orbs(); track orb.label) {
            <span [class]="'orb ' + orb.state"
                  [matTooltipPosition]="state.collapsed() ? 'right' : 'below'"
                  [matTooltipShowDelay]="200"
                  [matTooltip]="orb.tooltip"></span>
        }
    </a>
}

<nav aria-label="Hoofdmenu">
    @for (group of groups(); track group.title) {
        <div class="group">
            @if (state.collapsed()) {
                <span aria-hidden="true" class="group-line"></span>
            } @else {
                <span class="group-title">{{ group.title }}</span>
            }
            @for (item of group.items; track item.label) {
                <a #rla="routerLinkActive"
                   [attr.aria-current]="rla.isActive ? 'page' : null"
                   [class.active]="rla.isActive || isUnder(item.alsoActiveUnder)"
                   [matTooltipDisabled]="!state.collapsed()"
                   [matTooltipShowDelay]="200"
                   [matTooltip]="item.tooltip ?? item.label"
                   [routerLink]="item.link"
                   class="item"
                   matTooltipPosition="right"
                   routerLinkActive>
                    <span class="icon-wrap">
                        <ng-container *ngTemplateOutlet="icon; context: {$implicit: item.icon}"></ng-container>
                        @if (item.badge && state.collapsed()) {
                            <span aria-hidden="true" class="dot"></span>
                        }
                    </span>
                    <span class="label">{{ item.label }}</span>
                    @if (item.badge && !state.collapsed()) {
                        <span [attr.aria-label]="item.badge + ' wachten op goedkeuring'" class="badge">{{ item.badge }}</span>
                    }
                </a>
            }
        </div>
    }
</nav>

<div class="bottom">
    @if (loggedIn()) {
        <a #profile="routerLinkActive"
           [class.active]="profile.isActive"
           [matTooltipDisabled]="!state.collapsed()"
           [matTooltipShowDelay]="200"
           [routerLink]="['/', Routenames.profile]"
           class="item"
           matTooltip="Profiel"
           matTooltipPosition="right"
           routerLinkActive>
            <span class="icon-wrap"><ng-container *ngTemplateOutlet="icon; context: {$implicit: 'profile'}"></ng-container></span>
            <span class="label">Profiel</span>
        </a>
        <a [matTooltipDisabled]="!state.collapsed()"
           [matTooltipShowDelay]="200"
           [routerLink]="['/', Routenames.logout]"
           class="item"
           matTooltip="Uitloggen"
           matTooltipPosition="right">
            <span class="icon-wrap"><ng-container *ngTemplateOutlet="icon; context: {$implicit: 'logout'}"></ng-container></span>
            <span class="label">Uitloggen</span>
        </a>
    }
    @if (!state.narrow()) {
        <button (click)="state.toggle()"
                [attr.aria-expanded]="!state.collapsed()"
                [matTooltipDisabled]="!state.collapsed()"
                [matTooltipShowDelay]="200"
                class="item toggle"
                matTooltip="Uitklappen"
                matTooltipPosition="right"
                type="button">
            <span class="icon-wrap"><ng-container *ngTemplateOutlet="icon; context: {$implicit: 'collapse'}"></ng-container></span>
            <span class="label">Inklappen</span>
        </button>
    }
</div>
